export default __webpack_public_path__ + "media/images/suivi-jaune-08eb2d5606314847e086c829c554137a.png";